import styled from "styled-components";

const StyledListProblem = {
  Container: styled.div`
    display: flex;
    flex-direction: column;

    padding-top: 10px;
  `,

  DivRowBetween: styled.div<{ isMobile: boolean }>`
    display: flex;
    flex-direction: ${({ isMobile }) => (isMobile ? "column" : "row")};
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  `,

  TextArea: styled.textarea`
    padding: 10px;
    font-family: "Inter";
    border-radius: 10px;
  `,
};

export default StyledListProblem;
